<template>
  <el-container v-page-title="section.title">
    <!--页面导航-->
    <page-nav :pageNavObj="pageNavObj"></page-nav>
    <!--视频播放-->
    <div>
      <div class="prism-player" id="player-con">
      </div>
      <div class="need-verify" :style="{visibility: verifyIsHidden ? 'hidden':'visible'}">
          <h2>{{section.title}}</h2>
          <div style="margin-top: 50px">
            <div :style="{display: verifyIsLogin ? 'none':''}">
              <el-button type="primary" @click="toLogin">登录</el-button>
              <br>
              <p style="margin-top: 10px">  登录后才可以观看视频哦 ^ - ^</p>
            </div>
            <div :style="{display: verifyIsBug ? 'none':''}">
              <!--<el-button type="primary" @click="toOrder">付费</el-button>-->
              <!--<p style="margin-top: 10px">  付费后才可以观看视频哦 ^ - ^</p>-->
              <p style="margin-top: 10px">  不是该学习班课程哦 ^ - ^ </p>
            </div>
          </div>
      </div>
      <el-card class="box-card">
      </el-card>
      <!--课程tab-->
      <course-tab :courseId="course.id" :course="course"></course-tab>
      <!--推荐课程-->
      <recommend-course course-type="O"></recommend-course>
    </div>
  </el-container>
</template>

<script>
  import { initAliyunPlayer } from '@/utils/aliyun-player-init'
  const PageNav = () => import('@/components/course/PageNav');
  const CourseTab = () => import('@/components/course/CourseTab');
  const RecommendCourse = () => import('@/components/course/RecommendCourse');
  export default {
    name: 'detail',
    components: {
      PageNav,
      CourseTab,
      RecommendCourse
    },
    data() {
      return {
        course: {}, // 课程对象
        section: {}, // 小节对象
        pageNavObj: {}, // 页面导航对象
        videoSource: {
          videoMeta: {}
        }, // 视频播放资源对象
        player: null,  // 播放器
        activeName: 'second',
        isBindingKeyDown: false,
        verifyIsHidden: true, // 验证信息是否隐藏
        verifyIsLogin: true, // 验证是否登录
        verifyIsBug: true, //验证是否购买
        verfiyCode: '', //验证码
        studyStatus: '', //用户小节学习状态
        isFree: false, // 是否小节免费
      }
    },
    methods: {
      // 视频播放
      playerPlay() {
        this.player.play();
      },
      // 视频暂停
      playerPause() {
        this.player.pause();
      },
      // 监控视频播放
      onPlayerPlay() {
        // 视频播放时，若未进行键盘绑定，则添加键盘绑定
        if (!this.isBindingKeyDown) this.bindingKeyDown();
      },
      // 播放器时间变化
      onPlayerTimeupdate() {
        this.watchTime = this.player.getCurrentTime();
      },
      // 截图
      snapshoted(data) {
        var pictureData = data.paramData.base64;
        var downloadElement = document.createElement('a');
        downloadElement.setAttribute('href', pictureData);
        var fileName = 'Huaraun' + Date.now() + '.png';
        downloadElement.setAttribute('download', fileName);
        downloadElement.click();
        pictureData = null;
      },
      // 点击或者键盘空格播放器
      clickOrKeyPlayer() {
        if (this.player.getStatus() != 'playing') {
          this.playerPlay();
        }else {
          this.playerPause();
        }
      },
      // 视频播放绑定键盘事件
      bindingKeyDown() {
        this.isBindingKeyDown = true;
        let self = this;
        document.onkeydown = function (e) {
          let keyNum = window.event ? e.keyCode : e.which;
          let playVolume = self.player.getVolume();
          let playTime = self.player.getCurrentTime();
          let duration = self.player.getDuration();
          // 返回false阻止浏览器滚动
          switch (keyNum) {
            case 32:
              self.clickOrKeyPlayer();
              return false;
              break;
            case 37:
              playTime > 10 ? self.player.seek(playTime-10) : self.player.seek(0);
              return false;
              break;
            case 39:
              playTime < duration-10 ? self.player.seek(playTime+10) : self.player.seek(duration);
              return false;
              break;
            case 38:
              playVolume<0.9 ? self.player.setVolume(playVolume+0.1) : self.player.setVolume(1);
              return false;
              break;
            case 40:
              playVolume>0.1 ? self.player.setVolume(playVolume-0.1) : self.player.setVolume(0);
              return false;
              break;
          }
        }
      },
      // 取消键盘绑定
      unBindKeyDown(){
        this.isBindingKeyDown = false;
        document.onkeydown = null;
      },
      async queryByCourseId(courseId) {
        const {content} = await this.$http.get('/business/web/course/queryById',{params:{courseId:courseId}});
        this.course = content;
        if (this.course.isValidDate){
          if (this.$route.params.sectionId){
            await this.queryBySectionId(this.$route.params.sectionId)
          }
        }else {
          await this.$alert('该时段不允许播放本课程', '提示', {
            confirmButtonText: '确定',
            type: "warning"
          });
        }

        this.initPageNavObj();
      },
      async queryBySectionId(sectionId) {
        const {content} = await this.$http.get('/business/web/section/queryById',{params:{sectionId:sectionId}});
        this.section = content;

        await this.queryByTarget();

        this.initPageNavObj();
      },
      async queryByTarget() {
        const data = await this.$http.post('/business/web/section/queryByTarget',
          {'sectionId':this.section.id,
            'targetId':this.section.targetId,
            'targetType':this.section.targetType,
            'courseType':'O'});

        if (data.code === '2002') {
          this.verifyIsHidden = false;
          this.verifyIsLogin = false;
        }else if(data.code === '2003') {
          this.verifyIsHidden = false;
          this.verifyIsBug = false;
        }else if(data.code === '2001') {
          this.isFree = true;
          // 初始化阿里云播放器
          this.videoSource = data.content.videoSource;
          this.initVod();
        }else if(data.code === '2000') {
          this.verfiyCode = data.code;
          let content = data.content;
          // SessionStorage进行存储最后播放时间与记忆播放组件交互
          if (content.lastPlayedTime != undefined && content.lastPlayedTime!= 0 ) {
            SessionStorage.set("lastPlayedTime",content.lastPlayedTime);
          }else {
            SessionStorage.remove("lastPlayedTime");
          }
          this.studyStatus = content.userSectionStudyStatus;
          // 初始化阿里云播放器
          this.videoSource = content.videoSource;
          this.initVod();
        }
      },
      // 初始化阿里云播放器
      initVod() {
        let self = this;

        //初始化阿里云播放器(播放地址播放)
        self.player = initAliyunPlayer(self.videoSource);
        //开始播放时
        self.player.on('play', e => { self.onPlayerPlay(); });
        //播放时间更新时
        self.player.on('timeupdate', e => { self.onPlayerTimeupdate(); });
        // 截图
        self.player.on('snapshoted', data => {self.snapshoted(data); });
        // 当视频播放完毕
        self.player.on('ended', data => {self.onPlayerEnded(); });

        // 禁用视频加载
        // document.getElementsByClassName('prism-loading')[0].firstChild.style.display = 'none';
        // 视频video绑定点击事件
        document.querySelector('#player-con>video').addEventListener('click',this.clickOrKeyPlayer);
        // 绑定页面点击事件
        document.onclick = function(e){
          // 判断视频是否正在播放
          if(self.player.getStatus() != 'playing') {
            // 判断是否已绑定键盘
            if (self.isBindingKeyDown) {
              // 判断是否点击非视频区域
              if (!document.querySelector('#player-con').contains(e.target)) {
                // 解除键盘绑定
                self.unBindKeyDown();
              }
            }
          }
        };
      },
      initPageNavObj() {
        this.pageNavObj = {
          courseType: this.course.courseType,
          courseId: this.course.id,
          courseName: this.course.name,
          sectionTitle: this.section.title
        }
      },
      toLogin() {
        this.$router.push({ path: '/login' });
      },
      toOrder() {
        this.$router.push(({ path: `/home/orderConfirm/${this.course.id}`}))
      },
      // 页面刷新或者关闭
      refreshAndClose() {
        // 当非免费观看 记录最后播放时间
        if (!this.isFree && this.player && this.player.getCurrentTime()>0) {
          this.recordLastPlayTime();
        }
      },
      async recordLastPlayTime() {
        await this.$http.post('/business/web/userSection/recordLastTimeAndUpdatimeStatus',
          {"sectionId":this.section.id,"lastPlayTime":parseInt(this.player.getCurrentTime())});
      },
      async onPlayerEnded() {
        // 当学习状态未完成，修改学习状态
        if (!this.isFree && this.studyStatus != 'Y') {
          await this.$http.post('/business/web/userSection/completeSectionStudy',
            {"courseId":this.course.id,"sectionId":this.section.id});
        }
      }
    },
    created() {
      // 监听页面刷新和关闭
      window.addEventListener('beforeunload', e => this.refreshAndClose(e));

    },
    // 路由更新
    beforeRouteLeave (to, from, next) {
      if (!this.isFree && this.player && this.player.getCurrentTime()>0) {
        this.recordLastPlayTime();
      }
      // 解除键盘绑定
      this.unBindKeyDown();
      document.onclick = null;
      next()
    },
    beforeRouteUpdate(to,from,next) {
      this.refreshAndClose();
      if (this.player) this.player.dispose();
      let courseId = to.params.courseId;
      let sectionId = to.params.sectionId;
      this.queryByCourseId(courseId);
      // this.queryBySectionId(sectionId);

      next();
    },
    mounted() {
      let courseId = this.$route.params.courseId;
      let sectionId = this.$route.params.sectionId;

      this.queryByCourseId(courseId);
      // this.queryBySectionId(sectionId);
    },
  }
</script>


<style scoped>
  .el-container {
    width: 1098px;
    min-width: 1098px;
    margin: 35px auto 0 auto;
  }
  .prism-player {
    width: 1099px;
    height: 619px;
  }
  .need-verify {
    text-align: center;
    color: #0b76de;
    position: relative;
    top: -450px;
    height: 175px;
  }
  .box-card {
    width: 100%;
    margin-top: -195px;
    height: 60px;
  }
</style>
